import type {ButtonProps} from '@yandex-delivery/blocks'
import {useCallback} from 'react'

import type {PaymentCardErrorCode} from '../../../../../api/payment'
import {usePaymentCardErrorButtonProps} from '../hooks/usePaymentCardErrorButtonProps'

export type UseButtonPropsReturn = {
  cardErrorCode?: PaymentCardErrorCode
  onPress?: VoidFunction
}

export function useButtonProps({onPress, cardErrorCode}: UseButtonPropsReturn): ButtonProps {
  const handleOpenChangeCardModal = useCallback(() => {
    onPress?.()
  }, [onPress])

  return Object.assign<ButtonProps, ButtonProps | undefined>(
    {
      onPress: handleOpenChangeCardModal,
      shape: 'circle',
      textVariant: 'caption1',
      type: 'button',
      variant: 'ghost',
    },
    usePaymentCardErrorButtonProps(cardErrorCode),
  )
}
